import * as Yup from "yup";
import {
  phoneRegex,
  yupTestCheckFileSize,
  yupTestCheckFileType,
} from "../../../utils/validation";
import { ASSET_ICON_TYPES, STANDARD_ICONS_SLUGS } from "../account/constants";

export type TStandardIconKey =
  (typeof STANDARD_ICONS_SLUGS)[keyof typeof STANDARD_ICONS_SLUGS];

export type TIconTypeKey =
  (typeof ASSET_ICON_TYPES)[keyof typeof ASSET_ICON_TYPES];

// form field names
export type TFormFieldNames =
  | "vehicle_id"
  | "asset_image_url"
  | "creation_date"
  | "server_id"
  | "firmware_version"
  | "unique_id"
  | "is_active"
  | "sparseeventreporting"
  | "vehicle_description"
  | "short_name"
  | "vin"
  | "vehicle_make"
  | "vehicle_model"
  | "license_plate"
  | "license_expiration"
  | "equipment_type"
  | "equipment_status"
  | "asset_type"
  | "vehicle_class"
  | /*"imei_number" | "serial_number" | "phone_number" |
  "email" | "group_pushpin_id" | "map_route_color" |*/ "ignition_input"
  | "maximum_speed"
  | "driver_id"
  | "driver_name"
  | "driver_phone_number"
  | "fuel_type"
  | "fuel_capacity"
  | "fuel_economy"
  | "fuel_cost"
  | "recorder_id"
  | "recorder_on"
  | "recorder_type"
  | "previous_recorder_id"
  | "recorder_id_last_changed"
  | "selected_groups"
  | "group_selector"
  | "all_groups"
  | "standard_icon_key";

// initial values for the form
export const vehicleFormInitialValues = {
  vehicle_id: "",
  asset_image_url: "",
  creation_date: new Date(),
  server_id: "",
  firmware_version: "",
  previous_unique_id: "",
  unique_id_last_changed: 0,
  unique_id: "",
  groupid: "",
  reported_odometer: 0,
  reported_hours: 0,
  odometer_offset: "",
  engine_hours_offset: "",
  is_active: false,
  is_border_crossing: false,
  sparseeventreporting: false,
  vehicle_description: "",
  short_name: "",
  vin: "",
  vehicle_make: "",
  vehicle_model: "",
  vehicle_year: null as number | null,
  license_plate: "",
  license_expiration: 0,
  equipment_type: "",
  equipment_status: "",
  asset_type: "",
  vehicle_class: "",
  /*imei_number: "",
  serial_number: "",
  phone_number: "",
  email: "",
  group_pushpin_id: "",
  map_route_color: "",*/
  ignition_input: 0,
  maximum_speed: 0,
  driver_id: "",
  driver_name: "",
  driver_phone_number: "",
  fuel_type: 0,
  fuel_capacity: 0,
  fuel_economy: 0,
  fuel_cost: 0,
  recorder_id: "",
  recorder_on: 0,
  recorder_type: 0,
  previous_recorder_id: "",
  recorder_id_last_changed: 0,
  selected_groups: [] as string[] | { label: string; value: string }[],
  group_selector: "",
  all_groups: false,
  lasteventtimestamp: 0,
  device_id: "",
  odometer_sum: 0,
  hours_sum: 0,
  map_border_color: "",
  standard_icon_key: "" as TStandardIconKey | "",
  icon_type: "status-based" as TIconTypeKey | "",
};

const currentYear = new Date().getFullYear();

// validation schema for the form
// 4/14/2025 - validation shape moved to `vehicle-admin-details.tsx` for dynamic (API) validation
// export const vehicleFormValidationSchema = Yup.object().shape({
//   vehicle_model: Yup.string().required("Asset Model is required"), // number().max(currentYear, "Asset model cannot be in the future"),
//   vehicle_description: Yup.string().required("Asset Description is required"),
//   is_active: Yup.boolean().required("Is Active is required"),
//   creation_date: Yup.date().required("Creation Date is required"),
//   short_name: Yup.string().required("Display Name is required"),
//   ignition_input: Yup.string().required("Ignition Input is required"),
//   // phone_number: Yup.string().matches(phoneRegex, "Invalid phone"),
//   // driver_id: Yup.string()
//   //   .required("Please select a driver"),
//   maximum_speed: Yup.number().typeError("Please enter a numeric value"),
//   selected_groups: Yup.array().of(Yup.object()).when('all_groups', {
//     is: false,
//     then: schema => schema.min(1, "Either select \"All Groups\" option above, or at least one group from the option below"),
//     otherwise: schema => schema
//   }),
//   odometer_offset: Yup.number()
//   .typeError("Please enter a numeric value"),
//   engine_hours_offset:Yup.number()
//   .typeError("Please enter a numeric value"),
// });

export const groupMembershipFormValidationSchema = Yup.object().shape({});

export const vehicleUploadFormInitialValues = {
  deviceid: "",
  image: null,
};
export const vehicleUploadFormValidationSchema = Yup.object().shape({
  deviceid: Yup.string().required(),

  file: Yup.mixed<File>()
    .test("is-big-file", "VALIDATION_FIELD_FILE_BIG", yupTestCheckFileSize)
    .test(
      "is-correct-file",
      "VALIDATION_FIELD_FILE_WRONG_TYPE",
      yupTestCheckFileType
    ),
});
